import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Paper as Card } from 'LegacyWeployDesignLanguage/Card';
import { RemoveButton } from 'LegacyWeployDesignLanguage/buttons';

const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`;

const DismissableCard = ({ children, onClose }) => (
  <Card>
    <ButtonContainer><RemoveButton onClick={onClose} /></ButtonContainer>
    {children}
  </Card>
);

DismissableCard.propTypes = {
  onClose: PropTypes.func.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.element,
  ]).isRequired,
};

export default DismissableCard;

